/**
 * アコーディオンブロック - フロントエンドスクリプト
 *
 * アコーディオンの開閉機能を実装します。
 */

(function () {
  /**
   * アコーディオンの初期化
   */
  function initAccordion() {
    const accordions = document.querySelectorAll(
      ".wp-block-scd-block-accordion",
    );

    accordions.forEach((accordion) => {
      const items = accordion.querySelectorAll(
        ".wp-block-scd-block-accordion__item",
      );

      items.forEach((item) => {
        const header = item.querySelector(
          ".wp-block-scd-block-accordion__header",
        );
        const content = item.querySelector(
          ".wp-block-scd-block-accordion__content",
        );

        if (!header || !content) {
          return;
        }

        /**
         * クリックイベント
         */
        const animTiming = {
          duration: 400,
          easing: "ease-out",
        };
        const closingAnimKeyframes = (currentHeight) => [
          {
            height: currentHeight + "px", // height: "auto"だとうまく計算されないため要素の高さを指定する
            opacity: 1,
          },
          {
            height: 0,
            opacity: 0,
          },
        ];
        const openingAnimKeyframes = (targetHeight) => [
          {
            height: 0,
            opacity: 0,
          },
          {
            height: targetHeight + "px",
            opacity: 1,
          },
        ];
        header.addEventListener("click", () => {
          const isOpen = item.classList.contains("is-open");

          // 現在のアイテムの開閉を切り替え
          if (isOpen) {
            // 閉じるアニメーション: クラスを削除する前に現在の高さを取得
            const currentHeight = content.offsetHeight;

            // クラスを削除してaria属性を更新
            item.classList.remove("is-open");
            header.setAttribute("aria-expanded", "false");

            // アニメーションを開始
            const animation = content.animate(
              closingAnimKeyframes(currentHeight),
              animTiming,
            );

            // アニメーション完了後の処理
            animation.onfinish = () => {
              content.style.height = "0";
              content.style.opacity = "0";
              content.style.transition = ""; // トランジションを元に戻す
            };
          } else {
            // 開くアニメーション: クラスを追加してから高さを取得
            item.classList.add("is-open");
            header.setAttribute("aria-expanded", "true");

            // 一時的にheight: autoを設定して実際の高さを取得
            content.style.height = "auto";
            const targetHeight = content.offsetHeight;
            content.style.height = "0";

            console.log(targetHeight);
            // アニメーションを開始
            const animation = content.animate(
              openingAnimKeyframes(targetHeight),
              animTiming,
            );

            // アニメーション完了後の処理
            animation.onfinish = () => {
              content.style.height = "auto";
              content.style.opacity = "1";
              content.style.transition = ""; // トランジションを元に戻す
            };
          }
        });
      });
    });
  }

  /**
   * DOMContentLoaded時に初期化
   */
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAccordion);
  } else {
    initAccordion();
  }
})();
